module.exports = "<app-aside-nav></app-aside-nav>\n<div class=\"m-grid__item m-grid__item--fluid m-wrapper\">\n\t<router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/subheader--type-search/subheader--type-search.component.html
// module id = ../../../../../src/app/theme/pages/subheader--type-search/subheader--type-search.component.html
// module chunks = main